//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { get_merchant_all, area_list } from '@/api/jingxiaoshang'; //import commonTitle from '@/view/console/components/commonTitle'
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
// import BmCityList from 'vue-baidu-map/components/controls/CityList.vue'
// import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue'
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
// import BmLabel from 'vue-baidu-map/components/overlays/Label.vue'
// import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'

export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      merchantData: [],
      tableloading: false,
      formModel: {
        parent_code: [],
        merchant_code: ""
      },
      formRules: {
        merchant_code: [{
          required: true,
          message: '上级经销商不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {
      type: Boolean,
      default: false
    },
    $store: {},
    setData: {},
    parent_code: {},
    parent_name: {}
  },
  components: {},
  computed: {},
  methods: {
    getMerchantData: function getMerchantData(callback) {
      var _this = this;

      this.merchantData.splice(0);
      get_merchant_all({}).then(function (res) {
        if (res.result === 0) {
          var data = res.body; //console.log("a",data)

          _this.checkTree2(data);

          _this.merchantData = data;

          if (callback) {
            callback();
          }
        }
      });
    },
    checkTree2: function checkTree2(arr) {
      for (var i in arr) {
        arr[i].value = arr[i].merchant_code;
        arr[i].label = arr[i].shop_name;

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree2(arr[i].children);
        }
      }
    },
    init: function init() {}
  },
  mounted: function mounted() {
    if (this.edit) {
      if (this.setData) {
        //debugger
        console.log("aaa", this.setData); //Object.assign(this.formModel, this.setData)

        if (this.setData.parent_codes.length > 1) {
          this.$set(this.formModel, 'parent_code', this.setData.parent_codes);
        }

        this.$set(this.formModel, 'merchant_code', this.setData.merchant_code);
        console.log(this.formModel);
        this.getMerchantData(function () {//  console.log("a", this.merchantData)
          //  console.log("b",this.setData.merchant_code)
        });
      }
    } else {
      this.getAreaData();
      this.$set(this.formModel, 'parent_code', this.parent_code);
    }
  },
  created: function created() {// this.init()
  }
};